import { createAppRoute } from '@/router/common.js'
import { useAssetsStore } from '@/stores/tap/assets'
import { useInventoryItemTypesStore } from '@/stores/tap/inventory-item-types'
import { useRemoteCommandConfigsStore } from '@/stores/common/remote-command-configs'

export default [
  createAppRoute(
    () => import('@/views/tap/inventory-item-types/index.vue'),
    '/inventoryItemTypes',
    {
      requiresAuth: true,
      storeFn: useInventoryItemTypesStore,
    },
    'InventoryItemTypeListingPage'
  ),
  createAppRoute(
    () => import('@/views/tap/inventory-item-types/mono.vue'),
    '/inventoryItemTypes/mono',
    {
      requiresAuth: true,
      storeFn: useInventoryItemTypesStore,
    },
    'InventoryItemTypeForm'
  ),
  createAppRoute(
    () => import('@/views/tap/assets/index.vue'),
    '/assets',
    {
      requiresAuth: true,
      storeFn: useAssetsStore,
    },
    'AssetListingPage'
  ),
  createAppRoute(
    () => import('@/views/tap/assets/mono.vue'),
    '/assets/mono',
    {
      requiresAuth: true,
      storeFn: useAssetsStore,
    },
    'AssetForm'
  ),
  createAppRoute(() => import('@/views/common/remote-command-configs/mono.vue'), '/remote-command-configs/mono', {
    requiresAuth: true,
    storeFn: useRemoteCommandConfigsStore,
  }),
  createAppRoute(
    () => import('@/views/common/remote-command-configs/index.vue'),
    '/remote-command-configs',
    { requiresAuth: true, storeFn: useRemoteCommandConfigsStore },
    'remoteCommandConfigsListingPage'
  ),
]
